import { FunctionComponent, useMemo, type CSSProperties } from "react";

type ComponentType = {
  dimensionDescription?: string;
  imgIcon: string;
  coverageDescription?: string;

  /** Style props */
  divWidth?: CSSProperties["width"];
  divBackgroundColor?: CSSProperties["backgroundColor"];
};

const BlueBox: FunctionComponent<ComponentType> = ({
  imgIcon,
  coverageDescription,
  divWidth,
  divBackgroundColor,
}) => {
  const div1Style: CSSProperties = useMemo(() => {
    return {
      width: divWidth,
      backgroundColor: divBackgroundColor,
    };
  }, [divWidth, divBackgroundColor]);

  return (
    <div
      className="flex-1 w-full rounded-t-2xl rounded-b-none bg-purple shadow-[0px_-12px_16px_rgba(100,_88,_216,_0.3)] h-44 flex flex-col py-6 px-3 box-border items-center justify-start gap-[8px] min-w-[220px] text-center text-base text-white"
      style={div1Style}
    >
      <div className="w-[60px] h-[60px] flex flex-row items-center justify-center gap-[10px]">
        <img className="relative w-[60px]" alt="" src={imgIcon} />
      </div>
      <div className="self-stretch relative font-medium">
        {coverageDescription}
      </div>
    </div>
  );
};

export default BlueBox;
